<script>
import PowerDropsLeft from "./PowerDropsLeft.vue";
import Footer from "../../Footer.vue";
import CountDown from "@/components/checkout/CountDown.vue";
import CheckoutForm from "@/components/checkout/CheckoutForm.vue";

export default {
  name: "PowerDropsCheckout",
  page: {
    title: "Power Drops Next Level Checkout",
    meta: [{ name: "description", content: "Power Drops Next Level Checkout page." }],
  },
  props: {
    expirationDate: {
      type: Number,
      required: false,
      default: 0,
    },    
    combos: {
      type: Array,
      required: true,
    },
  },
  components: {
    PowerDropsLeft,
    CheckoutForm,
    Footer,
    CountDown,
  },
  created() {
    console.log(this.$route);
    this.combos = [29, 30];
    this.discount = "14%";
    console.log("Combo that is being sent to Checktou: " + this.combos);
  },
}
</script>

<template>  
  <b-container style="background-color: white; padding: 0 3rem 0 3rem">
    <!-- b-row>
      <b-col>
        <div style="text-align: center; margin-bottom: 2rem; padding: 3rem 3rem 0rem 3rem">
          MELANI METHOD LOGO
        </div>
      </b-col>
    </b-row-->

    <b-row>
      <b-col sm="12" class="time-counter-row header-checkout">
        <CountDown :expirationDate="expirationDate" />
      </b-col>
    </b-row>
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left">
        <PowerDropsLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="combos"
                      :expirationDate="expirationDate"
                      :changeBus="this" />
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col sm="12" lg="12">
        <b-card no-body>
          <b-row>
            <b-col md="4">
              <b-card class="text-center" border-variant="light" style="padding-top: 1.75rem">
                <b-card-img
                  img-top
                  :src="require('@/assets/powerdrops/thumb-melani.png')"
                  style="height: 90px; width: 90px; display: block; margin: auto"
                />
                <b-card-title title="Melani Kovač"></b-card-title>
                <b-card-body class="text-center"
                  >Dropsmart's (formerly Dropsmart) founder, Aromatherapist and Lecturer at Higher school of applied sciences</b-card-body
                >
              </b-card>
            </b-col>
            <b-col md="8">
              <b-card-body style="line-height: 1.5em; font-size: 1.2em; padding: 2rem">
                <h5 style="font-weight: bold">Your teacher</h5>
                <p>
                  Melani Kovač devoted her last 15+ years solely to promoting aromatherapy. To serve this purpose she’s founded
                  Aromainstitut through which she organises and supports different aromatherapy projects, collaborates with colleagues,
                  non-profit organisations, homes for the elderly, hospitals, universities and anyone who can benefit from aromatherapy or
                  is hoping to incorporate aromatherapy in their work. Her IT background, curiosity as well as working as an educator for a
                  very wide variety of students along with collaborating with distillers, sellers, nurses and scientists inspired her to
                  create a global online platform for all essential oil users and sellers - Dropsmart (formerly Dropsmart). Her goal is to make aromatherapy
                  simple, fun and as precise and as safe as possible.
                </p>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center" style="margin: 2rem 0 2rem 0">
        <h2 style="font-weight: 600; text-transform: uppercase">NEXT LEVEL POWER DROPS Program Modules</h2>
      </b-col>
      <b-col md="12" style="margin: 2rem 0 2rem 0">
        <ul style="padding-left: 1em; font-size: 1.5em;">
          <li>Module #1: Enhancing your essential oil chemistry awareness.</li>
          <li>Module #2: Introduction to Sinergy.</li>
          <li>Module #3: The Next Level of fundamentals.</li>
          <li>Module #4: Next steps &amp; sinergy.</li>
          <li>Module #5: Connecting the dots.</li>
          <li>Module #6: EXCLUSIVE BONUS with Modern cosmetics.</li>
          <li>Module #7: Chemistry &amp; aroma.</li>
          <li>Module #8: The power of sophisticated formulating.</li>
          <li>Module #9: Closing lessons - The full circle.</li>
          <li>Module #10: BONUS material &amp; clarifying your inquiries.</li>
        </ul>
      </b-col>

    </b-row>
    <b-row>
      <b-col md="12" class="text-center" style="margin: 2rem 0 2rem 0">
        <h2 style="font-weight: 600; text-transform: uppercase">MINI-MODULES AND MODERN COSMETICS BONUS</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <ul id="bonus-left">
          <li>15 Power Blending Mini Modules including:</li>
          <li style="list-style-type: none">
            <ul style="padding-left: 1em;">
              <li>Power blending for awesome skin results</li>
              <li>Power blending secrets for massage therapists</li>
              <li>Power blending tips &amp; tricks for moms &amp; kids</li>
              <li>Power blending for spotless cleaning with essential oils</li>
              <li>Power blending tips and tricks health professionals</li>
              <li>Power blending for anxiety and stress support</li>
              <li>Power blending for activating energy and focus</li>
              <li>Power blending for wellbeing</li>
              <li>Power blending to ease pain</li>
              <li>Power blending to strengthen and assist the immune system</li>
              <li>Power blending to support the respiratory system</li>
              <li>Power blending and creating the harmonious aroma</li>
              <li>Power blending simple steps to better sleep</li>
              <li>Power blending for yoga studios and meditation</li>
              <li>Power blending surprise module</li>
            </ul>
          </li>
          <li>5 Power Drops Mini Modules for aromatherapy educators</li>
        </ul>
      </b-col>
      <b-col md="6">
        <ul id="bonus-right">
          <li>2 Modern CosmEthics exclusive surprises</li>
          <li style="list-style-type: none">
            <ul>
              <li>
                <p>
                  Exclusive Modern CosmEthics training with the mastermind and chief editor of the globally acclaimed Modern Cosmetics book
                </p>
                <strong>Prof. Dr. Nina Kočevar Glavač</strong>
                <img src="@/assets/powerdrops/modern-cosmetics-1.jpg" />
                <br />
                <h4><strong>Module 1</strong></h4>
                <span>Natural Cosmetics - What is there to know?</span>
                <h4><strong>Module 2</strong></h4>
                <span>Vegetable butters and oils: Scientific evidence for cosmetic and therapeutic use</span>
              </li>
              <li>
                <p>Exclusive Modern CosmEthics practical workshop with <strong>Katja Schoss, MSc, Bachelor of Cosmetic Sciences</strong></p>
                <img src="@/assets/powerdrops/modern-cosmetics-2.jpg" />
              </li>
            </ul>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div style="margin-top: 3rem; text-align: center">
          <button
            class="button-checkout"
            style="max-width: 22em"
            v-scroll-to="'#time-counter-container'"
            @click="changeBus.$emit('start-filling-form')"
          >
            <span id="button-text">Click here to enroll in the Next Level now</span>
          </button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="text-center">
        <div style="margin-top: 2rem">
          <h2 style="font-weight: 600; font-size: 1.5em; margin-top: 2em">30-day money-back guarantee</h2>
        </div>
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
$vs-state-active-bg: #f7f7f7;
$vs-state-active-color: #444;

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 600;
    color: black ;
  }
}
@media screen and (min-width: 481px) {
  /*.header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }*/
}
.checkout-content {
  padding-bottom: 0;
  margin-bottom: 0;
  display: flex;
  align-items: stretch;
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}
.call-to-action {
  margin: 50px 0 10px;
  height: 80px;
  background-image: url(../../../assets/powerdrops/call-to-action-background.png);
  background-size: contain;
  background-repeat: no-repeat;
}
.call-to-action h2 {
  font-family: "OpenSans";
  font-size: 36px;
  color: #b8b8b8;
  text-transform: uppercase;
  line-height: 1.3;
}

#time-counter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 40px 0;
}

#time-counter-container div {
  width: 3em;
  font-size: 3rem;
  font-weight: 400;
}
#time-counter-container span {
  float: right;
}
#time-counter-container .value {
  height: 60px;
}
#time-counter-container .label {
  font-weight: normal;
  font-size: 0.9rem;
  width: auto;
  text-align: center;
  text-transform: uppercase;
  color: #555;
}

#bonus-left {
  font-size: 1.05rem;
  line-height: 2.75em;
}

ul#bonus-left > li {
  font-weight: bold;
  list-style: disc;
}
ul#bonus-left > li li {
  font-weight: normal;
  list-style: disc;
}

ul#bonus-right {
  line-height: 2.75em;
  width: 88%;
}

ul#bonus-right > li {
  font-weight: bold;
  list-style: disc;
}

ul#bonus-right > li li {
  font-weight: normal;
  line-height: 1em;
  margin-bottom: 2rem;
  list-style: disc;
}

ul#bonus-right h4 {
  font-size: 1.1rem;
  margin-bottom: 6px;
  margin-top: 16px;
}
#expired-offer-link {
  font-size: 1.5rem;
  color: red;
  font-weight: 900;
}

#expired-offer-link:hover {
  color: red;
  text-decoration: underline;
}
#expired-offer-link:visited {
  color: red;
  text-decoration: none;
}
</style>
